import React from 'react'

export default function FooterHours({data}) {
    const menu_content = data.footer_main_menu.modular_content;
    const hours_component = data.footer_hours__footer_hours_component.modular_content;
  return (
    <div id="cic-footer-contact-info-container" className="d-flex">
        <div className='d-flex menu-footer'>
            {
                menu_content.map((item, index) => {
                    const openInNewTab = item.elements.footer_menu_links__footer_open_in_new_tab.value[0]?.name === "Yes";
                    return(
                        <div className='menu-footer-item' key={`menu-footer-${index}`}>
                            <a
                                className="cic-tag-global-nav"
                                data-menu={`Footer ${item.elements.footer_menu_links__footer_menu_label_name.value}`}
                                data-target="FOOTER"
                                title={item.elements.footer_menu_links__footer_menu_aria_label.value} 
                                aria-label={item.elements.footer_menu_links__footer_menu_aria_label.value} 
                                href={item.elements.footer_menu_links__footer_menu_link.value}
                                target={openInNewTab ? "_blank" : "_self"}
                            >
                                {item.elements.footer_menu_links__footer_menu_label_name.value}
                            </a>
                        </div>
                    )
                })
            }
        </div>
        <div id="cic-footer-contact-hours" aria-label="Check Into Cash call center operates Monday through Friday from 8 o'clock am to 7 o'clock pm Eastern Time">
            
            {
                hours_component.map((item, index) => {
                    return(
                        <div className="d-flex" key={`menu-footer-hours-${index}`}>
                            <a
                                className="cic-tag-global-nav"
                                data-menu={`Footer ${item.elements.footer_menu_links__footer_menu_label_name.value}`}
                                data-target="FOOTER"
                                target='_blank'
                                rel="noopener noreferrer" 
                                title={item.elements.footer_menu_links__footer_menu_aria_label.value} 
                                aria-label={`Click here to read more about - ${item.elements.footer_menu_links__footer_menu_aria_label.value}`} 
                                href={item.elements.footer_menu_links__footer_menu_link.value}
                            >
                                <p className="cic-paragraph--medium text-white">{item.elements.footer_menu_links__footer_menu_label_name.value}</p>
                            </a>
                            {
                                (index === 2) ? <></> : (  <span> | </span>)
                            }
                        </div>
                    )
                })
            }
        </div>
    </div>
  )
}
